// extracted by mini-css-extract-plugin
export default {"trigger":"src-layout-SalesChannelProductsLayout-style-module__trigger--43OcN"};